module.exports = __webpack_public_path__ + "img/02-the-greenest-kind.b3455958.jpg";